export default __webpack_public_path__ + "static/media/twitter-logo.6f3e9be7.png";